export type DayEntryKind = 'meeting' | 'missed' | 'end'

export interface DayEntry {
  time: string
  label: string
  kind: DayEntryKind
}

/** Just enough of a workday to establish: this person was busy. */
export const dayTimeline: DayEntry[] = [
  { time: '09:00', label: 'Leadership meeting', kind: 'meeting' },
  { time: '09:24', label: 'Missed call — John', kind: 'missed' },
  { time: '10:30', label: 'Product review', kind: 'meeting' },
  { time: '12:36', label: 'Missed call — Mom', kind: 'missed' },
  { time: '14:00', label: 'Board meeting', kind: 'meeting' },
  { time: '15:08', label: 'Missed call — Unknown', kind: 'missed' },
  { time: '18:00', label: 'End of day', kind: 'end' },
]

/** Three intents: an action, a piece of information, an urgency. */
export const hiddenIntents: string[] = [
  '“Can we meet tomorrow?”',
  '“Can you send me the presentation?”',
  '“I need to speak to you urgently.”',
]

export interface CallLogEntry {
  name: string
  detail: string
  time: string
  repeat?: number
}

/** A normal, native phone call log at the end of the day — no context at all. */
export const nativeCallLog: CallLogEntry[] = [
  { name: 'David Chen', detail: 'mobile', time: '17:52' },
  { name: 'Unknown', detail: '+44 7700 900118', time: '17:18' },
  { name: 'Mom', detail: 'mobile', time: '16:44' },
  { name: 'Sarah Bennett', detail: 'work', time: '15:08', repeat: 2 },
  { name: 'Unknown', detail: '+1 (415) 555-0147', time: '14:12' },
  { name: 'John Smith', detail: 'mobile', time: '12:36' },
  { name: 'Aurora Group', detail: 'office', time: '11:18' },
  { name: 'Unknown', detail: '+44 7700 900264', time: '10:41' },
  { name: 'John Smith', detail: 'mobile', time: '09:24', repeat: 2 },
]
